import Card from "@particles/card/Card";
import { CardVariations, TemplateProps } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

/**
 * This is the template D of cards. Used to display 3 cards in a row.
 * https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/BAU--WEB-?node-id=12726-24273&t=V25hgDk5WxpFYhUc-4
 */
const TemplateD = ({
  className,
  header,
  cardProps,
  rightSidebar,
}: TemplateProps & { rightSidebar: React.ReactNode }): React.ReactElement => {
  const CardVariations: CardVariations = {
    kicker: {
      color: "text-blue-175",
      extraClass: cn("font-freightSansPro text-base"),
    },
    title: {
      color: "text-gray-850",
      size: cn("text-xl font-lct font-semibold -tracking-2%"),
    },
    image: {
      position: "",
      width: cn("w-[calc(100%+2.5rem)] lg:w-full"),
      aspectRatio: "aspect-3x2",
      imageClassName: cn("object-cover"),
      extraClass: cn("-mx-5 lg:mx-0"),
      orientation: "landscape",
    },
    content: {
      width: cn("w-full"),
      extraClass: cn("pt-4 px-6 text-center lg:text-left lg:p-0 lg:pt-3"),
      blurb: {
        extraClass: cn(
          "!block font-lucida text-base mt-1 leading-norma font-medium -tracking-5% text-gray-750"
        ),
      },
    },
  };

  return (
    <div
      data-testid="card-template-component"
      data-template="template-b"
      className={cn("grid grid-cols-1 gap-8 lg:grid-cols-4", className)}
    >
      {header}

      <div className="col-span-1 lg:col-span-3">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {cardProps.map((props, index) => {
            return (
              <Card
                key={props.link + props.title}
                {...props}
                variations={CardVariations}
                className={cn("relative md:flex-col", {
                  "after:absolute after:-bottom-4 after:h-[1px] after:w-full after:bg-blue-100 md:after:bg-blue-100 lg:after:-right-4 lg:after:bottom-0 lg:after:top-0 lg:after:h-full lg:after:w-[1px]":
                    [0, 1, 2].includes(index),
                  "pb-4 after:h-[2px] lg:pb-0": index === 2,
                })}
              />
            );
          })}
        </div>
      </div>

      <div className="col-span-1">{rightSidebar}</div>
    </div>
  );
};

export default TemplateD;
